import {vnTemplate} from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class imagePickerGalleryEdit_template extends vnTemplate {
    
    protected parent: any;

    protected getTemplateHtml(): string {

        return `
            <div class="w-img-picker-form is-visible" data-bind="css: { 'is-visible': isShown }">
           
                <div class="img-picker-form">
                    <div class="form-header">
                        <div class="w-section-title">
                            <h3 class="section-title">Edit Group</h3>
                            
                            <!--<div class="dropdown">
                                <button type="button" class="btn only-icon icon i-option"></button>
                                <div class="dropdown-list">
                                     <button class="btn" type="button">view</button>
                                     <button class="btn" type="button">remove from gallery</button>
                                </div>
                            </div>-->

                        </div>
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>

                    <div class="form-body" >
                    
                        <div class="form-group">
                            <label class="form-label" for="">title</label>
                            <input class="input-text" type="text" data-bind="value: name">
                            <small data-bind="style: { color: nameError() ? 'red' : 'white'}, text: nameErrorMsg" class="form-error">Title is required</small>
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="">Description</label>
                            <textarea rows="4" id="gallery_description"></textarea>
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label" for="">Credit Text</label>
                            <textarea rows="4" id="gallery_credit_text"></textarea>
                        </div>

                        <div class="form-group">
                        
                           <ul class="img-picker-list edit-gallery" data-bind="foreach: images" id="img-picker-list">
                           
                                <li class="img-picker-item" draggable="true" data-bind="attr: {id: id }">
                                    <button class="btn-icon icon i-drag"><span>drag</span></button>
                                    <div class="dropdown">
                                        <!--<button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>-->
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-download" title="Download" type="button" data-bind="event: { click: $parent.onClickDownloadImage }"><span>Download</span></button>
                                             <button class="btn-icon icon i-full-size" title="View Original" type="button" data-bind="event: { click: $parent.onClickViewOriginalImage }"><span>View Original</span></button>
                                             <button class="btn-icon icon i-remove-to-gallery" title="Remove from Group" type="button" data-bind="event: { click: $parent.onClickRemoveImage }"><span>Remove from Group</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">
                                        <img data-bind="attr: {src: url, alt: altText }"> 
                                    </div> 
                                </li>
                           </ul>
                           
                        </div>
                        
                    </div>
                    
                     <div class="form-footer">

                        <button type="button" class="btn icon i-cancel" data-bind="event: { click: onClickCancel }">Cancel</button>
                        <button type="button" class="btn icon i-upload" data-bind="event: { click: onClickUploadImage }">Upload</button>
                        <div class="insert-dropdown">
                            <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button" style="margin-bottom: 1rem"><span>Insert Selected <br>and Save</span></button>
                            <div class="insert-dropdown-list">
                                <button class="btn-icon icon i-ins-ind" type="button" data-bind="event: { click: onClickInsertImagesIndividually}"title="Insert Individually" type="button"><span>Insert Individually</span></button>
                                <button class="btn-icon icon i-ins-gallery" type="button" data-bind="event: { click: onClickInsert.bind($data, '') }, css: { 'is-disable': images().length == 1 } "  title="Insert as Gallery" ><span>Insert as Gallery</span></button>
                                <button class="btn-icon icon i-ins-grid" type="button" data-bind="event: { click: onClickInsert.bind($data, 'grid_view') }" title="Insert as Grid"><span>Insert as Grid</span></button>
                            </div>
                        </div>
                        <button type="button" class="btn icon i-save highlight" data-bind="event: { click: onClickView }">Save and View</button>
                        <button type="button" class="btn icon i-save highlight" data-bind="event: { click: onClickSave }">Save</button>
                        
                    </div>
                    
                </div>
            </div>

            `;
    }

    private onLoadTemplate () {

        var parent = this;

        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll('#img-picker-list .img-picker-item');
            let index = 0;
            let found = false;
            for(let item of dragItems){
                if(dragSrcEl == item){

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if(this == item){

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if(!found){
                this.classList.add("before");
            }
            //this.classList.add("before");

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {


                var dropHTML = e.dataTransfer.getData('text/html');

                if(dropHTML.includes("<li")){
                    for(let child of this.parentNode.childNodes){

                        if(child == dragSrcEl){
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }


                    if(this.classList.contains("before")){
                        this.insertAdjacentHTML('beforebegin',dropHTML);
                        var dropElem = this.previousElementSibling;
                    }else{
                        this.insertAdjacentHTML('afterend',dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }



            }
            parent.reorderImages();
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
              col.classList.remove('before');
              col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll('#img-picker-list .img-picker-item');
        [].forEach.call(cols, addDnDHandlers);


    }

    public setParent(parent){

        this.parent = parent;
    }
    

    protected initPartial(): void {

    }

    protected getTemplateName(): string {
        return "imagePickerGalleryEdit-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            idGallery: ko.observable(null),
            isShown: ko.observable(false),
            name: ko.observable(null),
            description: ko.observable(null),
            creditText: ko.observable(null),
            images: ko.observableArray([]),
            isImageOptimizable:  ko.observable(false),
            dateCreated: ko.observable(null),
            nameError: ko.observable(false),
            nameErrorMsg: ko.observable("Title is required"),
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onLoadTemplate: function(data, event){ huit_neuf_this.onLoadTemplate();},
            onClickInsert: function(param, data, event){ huit_neuf_this.onClickInsert(param, data);},
            onClickSave: function(data, event){ huit_neuf_this.onClickSave();},
            onClickView: function(data, event){ huit_neuf_this.onClickView();},
            onClickRemoveImage: function(data, event){ huit_neuf_this.onClickRemoveImage(data);},
            onClickViewImage: function(data, event){ huit_neuf_this.onClickViewImage(data);},
            onClickUploadImage: function(data, event){ huit_neuf_this.onClickUploadImage();},
            onClickDownloadImage: function(data, event){ huit_neuf_this.onClickDownloadImage(data);},
            onClickViewOriginalImage: function(data, event){ huit_neuf_this.onClickViewOriginalImage(data);},
            onClickInsertImagesIndividually: function(data, event){ huit_neuf_this.onClickInsertImagesIndividually();},
        };
    }

    protected onClickCancel(){
        this.getTemplateViewModel().nameError(false);
        this.hide();
    }


    public setIsImageOptimizable(isImageOptimizable: boolean): void {
        this.getTemplateViewModel().isImageOptimizable(isImageOptimizable);
    }

    public isImageOptimizable(): boolean {
        return this.getTemplateViewModel().isImageOptimizable();
    }

    protected reorderImages(){
        let images = this.getTemplateViewModel().images();
        let liElements = document.querySelectorAll('#img-picker-list .img-picker-item');

        //reorder the images based on HTML order
        let newImages = []
        for(let element of liElements){

            let idElement = element.id;
            let image = images.find(i => Number(i.id) === Number(idElement));
            if(image){
                newImages.push(image);
            }
        }
        this.getTemplateViewModel().images([]);
        this.getTemplateViewModel().images(newImages);
        this.onLoadTemplate();
    }

    protected onClickViewImage(data){

       this.parent.viewImage(data);
    }

    protected onClickRemoveImage(item){

        this.reorderImages();

        let images = this.getTemplateViewModel().images();
        if(images.length > 1){
            images.splice(images.findIndex(i => i.id === item.id),1);
            this.getTemplateViewModel().images([]);
            this.getTemplateViewModel().images(images);
        }
        this.onLoadTemplate();
        //images.refresh(item);
    }
    
    protected onClickDownloadImage(data){
        this.parent.onClickDownload(data)
    }

    protected onClickViewOriginalImage(image){
        this.parent.getFile(image.url, image.name, false);
    }

    protected onClickSave(){

        this.saveGallery(false, '');
    }

    protected onClickView(){

        if(this.saveGallery(false, '')){
          this.parent.viewGallery(this.getGallery());
        }
    }

    protected onClickUploadImage(){

        this.parent.addImage();
    }

    public addImage(image){

        let images = this.getTemplateViewModel().images();
        images.push(image);
        this.getTemplateViewModel().images([]);
        this.getTemplateViewModel().images(images);
        this.onLoadTemplate();
        //this.reorderImages();
    }

    public refreshImage(image){

        let images = this.getTemplateViewModel().images();
        let index = images.findIndex(i => i.id == image.id);
        if(~index){
            images[index] = image;
        }
        this.getTemplateViewModel().images([]);
        this.getTemplateViewModel().images(images);
        this.onLoadTemplate();
    }

    protected saveGallery(insert, param){
        if(this.isFormValid()){
            this.reorderImages();
            this.parent.saveGallery(this.getGallery(), insert, param);
            this.hide();
            return true;
        }else{
            return false;
        }
    }

    protected getGallery(){

        let viewModel = this.getTemplateViewModel();
        let gallery = { id: viewModel.idGallery(),
            name: viewModel.name() ,
            description: this.caller.getGalleryDescription(),
            creditText: this.caller.getGalleryCreditText(),
            images: viewModel.images() };

        return gallery;
    }

    protected onClickInsert(param, data){

        //have to insert after save
        if(this.saveGallery(true, param)){
            this.hide();
        }
    }

    protected onClickInsertImagesIndividually(){

        let gallery = this.getGallery()
        let images = gallery.images;

        for (let image of images){

            image.isMobileOptimized = (this.isImageOptimizable() && image.isLandscape && !image.isWaterMark);
            this.parent.insertImage(image, '');
        }

    }

    public setGallery(gallery){

        if(gallery){
            this.getTemplateViewModel().idGallery(gallery.id);
            this.getTemplateViewModel().name(gallery.name);
            this.getTemplateViewModel().description(gallery.description);
            this.getTemplateViewModel().images([]);
            this.getTemplateViewModel().images(gallery.images);

            this.caller.setGalleryDescription(gallery.description);
            this.caller.setGalleryCreditText(gallery.creditText);
            this.onLoadTemplate();
        }

    }

    protected isFormValid(){
        let valid = true;
        this.getTemplateViewModel().nameError(false);

        let name = this.getTemplateViewModel().name();
        if(name == "" || name == null){
            this.getTemplateViewModel().nameError(true);
            valid = false;
        }

        return valid;
    }


    public show(){

        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        this.getTemplateViewModel().isShown(false);
    }

    public reset(){

        this.getTemplateViewModel().name(null);
        this.getTemplateViewModel().description(null);
        this.getTemplateViewModel().images([]);
    }

}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/imagePickerGalleryEdit_template.ts